import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import _, { uniq } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Col, message, notification, Row, Select, Space, Spin } from 'antd'
import {
  Button,
  ButtonActionBar,
  CustomBottomAction,
  DownloadModal,
  DropdownMenu,
  PeriodNavigator,
  Typography,
} from 'modules/core/components'
import { PROJECTION, REPORT, TABLES } from 'modules/core/constants'
import { ReportKPICarousel } from 'modules/reports/components'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { generateMessageError, generateSelectOptions, isInElaboration } from 'modules/core/utils'
import { ButtonDownloadPPT, TabsReports } from './components'
import { useDefaultCurrency, usePagination } from 'modules/core/customHooks'
import { SolutionOutlined, ShareAltOutlined } from '@ant-design/icons'
import forecast from 'modules/forecast'
import planning from 'modules/planning'
import reports from 'modules/reports'
import configuration from 'modules/configuration'
import login from 'modules/login'
import PropTypes from 'prop-types'

import './ReportDetail.scss'
import control from 'modules/control'

const DEFAULT_SELECT = {
  value: PROJECTION.REAL,
  id: null,
}

const ReportDetail = ({
  periodDetail,
  selectedDates,
  filters,
  commentKey,
  reportDetail: { columns, rows, lineId, name_report },
  fetchDataEvolution,
  fetchDataComparative,
  activeOptionPeriodTable,
  analysisKPIs,
  fetchGlobalBudgetList,
  fetchGlobalForecastFilterList,
  globalBudgetList,
  globalForecastFilterList,
  downloadReportPPTDrive,
  loggedUser: { folder_id },
  fetchReportDetailStructure,
  reportStructure,
  fetchDataGraphAndKpiByReport,
  dataKpisByReport,
  dataGraphByReport,
  fetchDataEvolutionByReport,
  fetchDataComparativeByReport,
  fetchCurrencyList,
  currencyList,
  fetchCommentsList,
  commentsList,
  fetchOverallBudgetSelectAnalysis,
  overallBudgetSelectAnalysis,
  type,
  shareLayout,
}) => {
  // Feature flag
  const enabledEvolutionTable = useFeatureIsOn('feature-react-pivot-evolution')
  const reportComparativeSrlections = useFeatureValue('report-comparative-selections', {
    reports: [],
  })
  const enableKpisReportId = useFeatureValue('enable-kpis-report-id', { reportId: null })

  const enabledComparativeTable = useFeatureIsOn('feature-react-pivot-comparative')
  const enabled = true
  const enableKpis = useFeatureIsOn('feature-visible-kpi')
  const enableGlobalBudgetDefaultComparative = useFeatureIsOn('ab-global-budget-default')
  const enableUrls = useFeatureIsOn('enable-urls')

  let { periodId, reportId, currency, tableType, base } = useParams()
  const DEFAULT_REFERENCE_COMPARISON = [PROJECTION.REAL_LAST_PERIOD]
  const [isLoadingGraphAndKpi, setIsLoadingGraphAndKpi] = useState(false)
  const [isScreenLoading, setIsScreenLoading] = useState(true)
  const [isEvolutionLoading, setIsEvolutionLoading] = useState(false)
  const [iscomparativeLoading, setIsComparativeLoading] = useState(false)
  const [periodTableSettings, setPeriodTableSettings] = useState(TABLES.DEFAULT_SETTINGS)
  const [selectedProjection, setSelectedProjection] = useState(DEFAULT_SELECT)
  const [referenceBase, setReferenceBase] = useState(DEFAULT_SELECT)
  const [referenceComparison, setReferenceComparison] = useState(DEFAULT_REFERENCE_COMPARISON)
  const [localReferenceBase, setLocalReferenceBase] = useState(DEFAULT_SELECT)
  const [keyComparisonTable, setKeyComparisonTable] = useState(REPORT.REPORTS_KEYS.ACCUMULATED)
  const [tablePagination, setTablePagination] = usePagination()
  const [tabKey, setTabKey] = useState(tableType || REPORT.REPORTS_KEYS.EVOLUTION_KEY)
  const [showModal, setShowModal] = useState(false)
  const [lineVertical, setLineVertical] = useState(null)
  const [currencyChange, setCurrencyChange] = useState(null)
  const [isCurrencyLoading, setIsCurrencyLoading] = useState(false)
  const [dataComments, setDataComments] = useState([])
  const [isLoadingComments, setIsLoadingComments] = useState(false)
  const defaultCurrencyData = useDefaultCurrency()
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [baseSelect, setBaseSelect] = useState(base)

  const [referenceBaseVariant, setReferenceBaseVariant] = useState(DEFAULT_SELECT)
  const [referenceComparisonVariant, setReferenceComparisonVariant] = useState({})
  const [settingsEvolution, setSettingsEvolution] = useState({})
  const [settingsComparison, setSettingsComparison] = useState({})
  const [settingsVariation, setSettingsVariation] = useState({})

  let history = useHistory()
  const { t } = useTranslation()

  const auxCurrencyId = currencyChange || defaultCurrencyData?.id

  let queryString = window.location.search
  let urlParams = new URLSearchParams(queryString)
  let reportLine = urlParams.get('reportLine')
  let table = urlParams.get('table')
  let comparison = urlParams.get('comparison')
  let comparisonVariation = urlParams.get('comparisonVariation')

  useEffect(() => {
    setIsLoadingComments(true)
    fetchCommentsList({ module: commentKey }).then(() => setIsLoadingComments(false))
  }, [fetchCommentsList, commentKey])

  useEffect(() => {
    setDataComments(commentsList)
  }, [commentsList])

  useEffect(() => {
    Promise.all([
      fetchGlobalForecastFilterList({ period_id: periodId }),
      fetchGlobalBudgetList({ period_id: periodId }),
    ])
  }, [fetchGlobalBudgetList, fetchGlobalForecastFilterList, periodId])

  useEffect(() => {
    fetchReportDetailStructure(reportId)
  }, [fetchReportDetailStructure, reportId])

  useEffect(() => {
    setIsCurrencyLoading(true)
    fetchCurrencyList().then(() => {
      setIsCurrencyLoading(false)
    })
  }, [fetchCurrencyList])

  useEffect(() => {
    const dataBaseSend = {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      type_report: selectedProjection,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    }
    setIsLoadingGraphAndKpi(true)
    fetchDataGraphAndKpiByReport(reportId, dataBaseSend).then(() => {
      setIsLoadingGraphAndKpi(false)
    })
  }, [
    fetchDataGraphAndKpiByReport,
    reportId,
    periodId,
    selectedDates,
    filters,
    selectedProjection,
    auxCurrencyId,
  ])

  useEffect(() => {
    if (tabKey !== REPORT.REPORTS_KEYS.EVOLUTION_KEY) return

    if (enabled) {
      if (!auxCurrencyId) return
    }

    setIsEvolutionLoading(true)
    setShowProgressBar(true)
    const dataBaseSend = {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      type_report: selectedProjection,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    }
    if (enabledEvolutionTable) {
      fetchDataEvolutionByReport(reportId, {
        ...dataBaseSend,
        vertical_analysis: lineVertical,
        page: tablePagination.page,
      })
        .then(() => {
          setIsScreenLoading(false)
          setIsEvolutionLoading(false)
          setTimeout(() => {
            setShowProgressBar(false)
          }, 2000)
        })
        .catch((e) => {
          setIsScreenLoading(false)
          setIsEvolutionLoading(false)
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(e, 'REPORT_DETAIL_FAIL_FEEDBACK_DESCRIPTION'),
            duration: 0,
          })
        })
    } else {
      fetchDataEvolution(reportId, {
        ...dataBaseSend,
        vertical_analysis: lineVertical,
        page: tablePagination.page,
      })
        .then(() => {
          setIsScreenLoading(false)
          setIsEvolutionLoading(false)
          setTimeout(() => {
            setShowProgressBar(false)
          }, 2000)
        })
        .catch((e) => {
          setIsScreenLoading(false)
          setIsEvolutionLoading(false)
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(e, 'REPORT_DETAIL_FAIL_FEEDBACK_DESCRIPTION'),
            duration: 0,
          })
        })
    }
    // eslint-disable-next-line
  }, [
    periodId,
    reportId,
    activeOptionPeriodTable,
    selectedDates,
    selectedProjection,
    tabKey,
    filters,
    auxCurrencyId,
  ])

  useEffect(() => {
    if (tabKey !== REPORT.REPORTS_KEYS.COMPARISON_KEY) return
    setIsComparativeLoading(true)
    setShowProgressBar(true)
    const dataBaseSend = {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      reference_base: referenceBase,
      reference_comparative: referenceComparison,
      comparative_projections: buildProjection(referenceBase, referenceComparison),
      report_type: keyComparisonTable,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    }

    if (enabledComparativeTable) {
      fetchDataComparativeByReport(reportId, dataBaseSend).then(() => {
        setIsComparativeLoading(false)
        setIsScreenLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
    } else {
      fetchDataComparative(reportId, dataBaseSend).then(() => {
        setIsComparativeLoading(false)
        setIsScreenLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
    }
    // eslint-disable-next-line
  }, [
    reportId,
    periodId,
    selectedDates,
    filters,
    referenceBase,
    referenceComparison,
    keyComparisonTable,
    tabKey,
    auxCurrencyId,
  ])

  useEffect(() => {
    if (tabKey !== REPORT.REPORTS_KEYS.VARIATION_KEY) return

    if (!_.isEmpty(referenceComparisonVariant)) {
      setIsComparativeLoading(true)
      setShowProgressBar(true)
      fetchDataComparativeByReport(reportId, {
        period_id: periodId,
        filter_date: selectedDates,
        filter: filters,
        reference_base: referenceBaseVariant,
        reference_comparative: referenceComparisonVariant,
        comparative_projections: buildProjectionVariant(
          referenceBaseVariant,
          referenceComparisonVariant,
        ),
        report_type: keyComparisonTable,
        ...(auxCurrencyId && { currency_id: auxCurrencyId }),
      }).then(() => {
        setIsComparativeLoading(false)
        setIsScreenLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
    }
    // eslint-disable-next-line
  }, [
    reportId,
    periodId,
    selectedDates,
    filters,
    referenceBaseVariant,
    referenceComparisonVariant,
    keyComparisonTable,
    tabKey,
    auxCurrencyId,
  ])

  const getDefaultBaseSelection = (configReport, baseSelect, budgetPublish, forecastPublish) => {
    if (configReport?.base === 'real' || (!configReport?.base && baseSelect === 'real')) {
      return DEFAULT_SELECT
    }

    if (configReport?.base === 'budget' && budgetPublish) {
      return { value: PROJECTION.BUDGET, id: budgetPublish.id }
    }

    if (configReport?.base === 'forecast' && forecastPublish) {
      return { value: PROJECTION.FORECAST, id: forecastPublish.id }
    }

    if (baseSelect) {
      const [projection, id] = baseSelect.split('-')
      return { value: projection, id }
    }

    return DEFAULT_SELECT
  }

  const getDefaultComparisonSelection = (
    configReport,
    enableGlobalBudgetDefaultComparative,
    comparison,
    budgetPublish,
    forecastPublish,
  ) => {
    if (configReport?.comparison) {
      if (configReport.comparison === 'real') {
        return [PROJECTION.REAL_LAST_PERIOD]
      }
      if (configReport.comparison === 'budget' && budgetPublish) {
        return [`${PROJECTION.BUDGET}-${budgetPublish.id}`]
      }
      if (configReport.comparison === 'forecast' && forecastPublish) {
        return [`${PROJECTION.FORECAST}-${forecastPublish.id}`]
      }
      return [PROJECTION.REAL_LAST_PERIOD]
    }

    if (enableGlobalBudgetDefaultComparative) {
      return [`${PROJECTION.BUDGET}-${budgetPublish.id}`]
    }

    if (comparison) {
      const json = Buffer.from(comparison, 'base64').toString()
      const dataComparison = JSON.parse(json)
      return [dataComparison[0]]
    }

    return [PROJECTION.REAL_LAST_PERIOD]
  }

  const getReferenceComparisonVariant = (
    comparisonVariation,
    budgetPublish,
    forecastPublish,
    globalBudgetList,
    globalForecastFilterList,
  ) => {
    const createVariant = (projection, id) => ({
      value: projection,
      id,
    })

    const handleComparisonVariation = (comparisonVariation) => {
      if (comparisonVariation === 'real') {
        return createVariant('real', null)
      }
      const [projection, id] = comparisonVariation.split('-')
      return createVariant(projection, id)
    }

    if (budgetPublish) {
      return comparisonVariation
        ? handleComparisonVariation(comparisonVariation)
        : createVariant(PROJECTION.BUDGET, budgetPublish.id)
    }

    if (forecastPublish) {
      return comparisonVariation
        ? handleComparisonVariation(comparisonVariation)
        : createVariant(PROJECTION.FORECAST, forecastPublish.id)
    }

    const budgetFirst = globalBudgetList?.values
      .filter((global) => !isInElaboration(global.status))
      .find((item) => item.predefined === false)

    const forecastFirst = globalForecastFilterList?.values
      .filter((global) => !isInElaboration(global.status))
      .find((item) => item.predefined === false)

    if (budgetFirst) {
      return comparisonVariation
        ? handleComparisonVariation(comparisonVariation)
        : createVariant(PROJECTION.BUDGET, budgetFirst.id)
    }

    if (forecastFirst) {
      return comparisonVariation
        ? handleComparisonVariation(comparisonVariation)
        : createVariant(PROJECTION.FORECAST, forecastFirst.id)
    }

    return null
  }

  useEffect(() => {
    if (globalBudgetList.values.length > 0 || globalForecastFilterList.values.length > 0) {
      const budgetPublish = globalBudgetList?.values
        .filter((global) => !isInElaboration(global.status))
        .find((item) => item.predefined === true)

      const forecastPublish = globalForecastFilterList?.values
        .filter((global) => !isInElaboration(global.status))
        .find((item) => item.predefined === true)

      const configReport = reportComparativeSrlections.reports.find(
        (el) => el.reportId === parseInt(reportId),
      )

      // Obtener selección base
      const defaultBaseSelection = getDefaultBaseSelection(
        configReport,
        baseSelect,
        budgetPublish,
        forecastPublish,
      )

      // Obtener selección de comparación
      const defaultComparisonSelection = getDefaultComparisonSelection(
        configReport,
        enableGlobalBudgetDefaultComparative,
        comparison,
        budgetPublish,
        forecastPublish,
      )

      // Obtener variación de comparación
      const referenceComparisonVariant = getReferenceComparisonVariant(
        comparisonVariation,
        budgetPublish,
        forecastPublish,
        globalBudgetList,
        globalForecastFilterList,
      )

      // Actualizar estados
      setReferenceBase(defaultBaseSelection)
      setReferenceComparison(defaultComparisonSelection)
      setLocalReferenceBase(defaultBaseSelection)

      if (referenceComparisonVariant) {
        setReferenceComparisonVariant(referenceComparisonVariant)
      }
    }
  }, [globalBudgetList.values, globalForecastFilterList.values])

  useEffect(() => {
    fetchOverallBudgetSelectAnalysis({ period_id: periodId })
  }, [fetchOverallBudgetSelectAnalysis, periodId])

  const groupProjection = {
    BUDGET: globalBudgetList?.values.filter((global) => !isInElaboration(global.status)),
    BUDGET_PREV_PERIOD: globalBudgetList?.values.filter(
      (global) => !isInElaboration(global.status),
    ), //AJUSTAR CUANDO VENGA DE BACK LA DATA
    FORECAST: globalForecastFilterList?.values.filter((global) => !isInElaboration(global.status)),
    FORECAST_PREV_PERIOD: globalForecastFilterList?.values.filter(
      (global) => !isInElaboration(global.status),
    ), //AJUSTAR CUANDO VENGA DE BACK LA DATA
  }

  useEffect(() => {
    if ((currency && auxCurrencyId) || (!currency && auxCurrencyId)) {
      setCurrencyChange(auxCurrencyId)
    } else {
      setCurrencyChange(parseInt(currency))
    }

    if (baseSelect) {
      if (baseSelect === 'real') {
        setSelectedProjection(DEFAULT_SELECT)
        setLocalReferenceBase(DEFAULT_SELECT)
      } else {
        const projection = baseSelect.split('-')[0]
        const id = baseSelect.split('-')[1]
        setSelectedProjection({ value: projection, id })
        setLocalReferenceBase({ value: projection, id })
      }
    } else {
      setSelectedProjection(DEFAULT_SELECT)
      setLocalReferenceBase(DEFAULT_SELECT)
    }

    if (reportLine) {
      setLineVertical(reportLine)
    } else {
      setLineVertical(null)
    }
  }, [currency, auxCurrencyId, baseSelect, reportLine])

  const renderHeader = () => (
    <PeriodNavigator
      items={[
        {
          name: t('LABEL_ANALYSIS'),
          url: `/analisis/${periodId}/reportesplika`,
        },
        {
          name: t('REPORT_PLIKA_CARD_TITLE'),
        },
        { name: reportStructure.name || '' },
      ]}
    />
  )

  const onRefetchComparative = () => {
    setIsComparativeLoading(true)
    fetchDataComparativeByReport(reportId, {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      reference_base: referenceBase,
      reference_comparative: referenceComparison,
      report_type: keyComparisonTable,
    }).then(() => {
      setIsComparativeLoading(false)
    })
  }

  const onRefetchEvolution = () => {
    setIsEvolutionLoading(true)
    fetchDataEvolutionByReport(reportId, {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      type_report: selectedProjection,
      vertical_analysis: lineVertical,
      page: tablePagination.page,
    }).then(() => {
      setIsEvolutionLoading(false)
    })
  }

  const onRefetch = () => {
    setIsEvolutionLoading(true)
    const dataBaseSend = {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      type_report: selectedProjection,
      page: tablePagination.page,
    }

    if (enabledEvolutionTable) {
      fetchDataEvolutionByReport(reportId, dataBaseSend).then(() => setIsEvolutionLoading(false))
    } else {
      fetchDataEvolution(reportId, dataBaseSend).then(() => setIsEvolutionLoading(false))
    }
  }

  const onRefetch2 = () => {
    setIsComparativeLoading(true)
    const dataBaseSend = {
      period_id: periodId,
      filter_date: selectedDates,
      filter: filters,
      reference_base: referenceBase,
      reference_comparative: referenceComparison,
      comparative_projections: buildProjection(referenceBase, referenceComparison),
      report_type: keyComparisonTable,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    }

    if (enabledComparativeTable) {
      fetchDataComparativeByReport(reportId, dataBaseSend).then(() =>
        setIsComparativeLoading(false),
      )
    } else {
      fetchDataComparative(reportId, dataBaseSend).then(() => setIsComparativeLoading(false))
    }
  }

  const getDataKpis = () => {
    if (enabledEvolutionTable) {
      return dataKpisByReport
    }
    return analysisKPIs
  }

  const getDataGraph = () => {
    if (enabledEvolutionTable) {
      return dataGraphByReport.rows
    }
    return rows
  }

  const normalizeProjection = (projection, id) => {
    if (projection === PROJECTION.BUDGET) {
      return `overallbudget-${id}`
    } else if (projection === PROJECTION.FORECAST) {
      return `forecastoverallbudget-${id}`
    } else {
      return projection
    }
  }

  const buildProjection = (base, comparisonc) => {
    const { value: baseValue, id: baseId } = base
    const valueBase = normalizeProjection(baseValue, baseId)

    const valueComparison = comparisonc.map((item) => {
      const [value, id] = item.split('-')
      return normalizeProjection(value, id)
    })

    return uniq([valueBase, ...valueComparison])
  }

  const buildProjectionVariant = (base, comparisonv) => {
    const { value: baseValue, id: baseId } = base
    const valueBase = normalizeProjection(baseValue, baseId)
    let valueComparison = null
    if (comparisonv) {
      const { value: comparisonValue, id: comparisonId } = comparisonv
      valueComparison = normalizeProjection(comparisonValue, comparisonId)
    }

    return uniq([valueBase, valueComparison]).filter((el) => el !== null)
  }

  const handleClick = (key) => {
    setCurrencyChange(key)

    const baseAux = localReferenceBase.id
      ? `${localReferenceBase.value}-${localReferenceBase.id}`
      : localReferenceBase.value

    const baseComparisonVariation = referenceComparisonVariant.id
      ? `${referenceComparisonVariant.value}-${referenceComparisonVariant.id}`
      : referenceComparisonVariant.value

    setBaseSelect(baseAux)

    let url = `/analisis/${periodId}/reportesplika/${reportId}/${type}/${key}/${tabKey}/${baseAux}`

    const params = []

    if (reportLine) {
      params.push(`reportLine=${reportLine}`)
    }

    if (comparison) {
      params.push(`comparison=${comparison}`)
    }

    if (table) {
      params.push(`table=${table}`)
    }

    if (comparisonVariation) {
      params.push(`comparisonVariation=${baseComparisonVariation}`)
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`
    }

    window.history.replaceState(null, '', url)
  }

  const renderExtraKey = () => {
    if (tabKey === 'evolution') return 'montly_evolution'
    if (tabKey === 'comparison') return 'coparations'
    if (tabKey === 'variation') return 'variation'
  }

  const handleOnClickCompartir = () => {
    const dataSettings = {
      ...(tabKey === 'evolution' && {
        ...settingsEvolution,
      }),
      ...(tabKey === 'comparison' && {
        ...settingsComparison,
      }),
      ...(tabKey === 'variation' && {
        ...settingsVariation,
      }),
    }

    const extraKey = renderExtraKey()

    const {
      aggregatorName,
      cols,
      columns,
      default_format,
      default_value,
      rendererName,
      vals,
      valueFilter,
      rows,
    } = dataSettings

    const dataTable = {
      ...(!_.isEmpty(dataSettings) && {
        aggregatorName,
        cols,
        columns,
        default_format,
        default_value,
        rendererName,
        vals,
        valueFilter,
        rows,
      }),
    }

    const urlObj = new URL(window.location.href)
    const pathAndQuery = urlObj.pathname + urlObj.search

    shareLayout('reports', `${periodId}-${reportId}-${extraKey}`, {
      path: pathAndQuery,
      config: { ...dataTable },
    })
      .then((response) => {
        message.success(t('FEEDBACK_COPY_URL_SUCCESS'), 8)
        const newUrl = response.payload.data.url_hash
        // .replace(
        //   'https://stg.getplika.com/',
        //   'http://localhost:3000/',
        // )
        navigator.clipboard.writeText(newUrl)
      })
      .catch((error) => {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  return (
    <div className="report-detail-container">
      <Spin spinning={isScreenLoading} size="large" />
      {!isScreenLoading && renderHeader()}
      <Row gutter={[8, 16]}>
        <Col span={24}>
          <ButtonActionBar position="space-between">
            <Space direction="horizontal">
              {enabled && (
                <>
                  <Typography.Body>{t('LABEL_CURRENCY')}:</Typography.Body>
                  <Select
                    bordered={false}
                    value={currencyChange ?? defaultCurrencyData?.id}
                    loading={isCurrencyLoading}
                    placeholder={t('ACTION_SELECT')}
                    options={generateSelectOptions({ options: currencyList.data })}
                    onChange={(val) => handleClick(val)}
                  />
                </>
              )}
            </Space>
            <Space direction="horizontal">
              <ButtonDownloadPPT
                reportId={reportId}
                params={{
                  period_id: periodId,
                  filter_date: selectedDates,
                  filter: filters,
                  type_report: selectedProjection,
                }}
                periodDetail={periodDetail}
                name_report={name_report}
                setShowModal={setShowModal}
              />
              <CustomBottomAction
                extraButtons={{ module_name: 'reportes', concept: '1', submodule_name: reportId }}
              />
              {enableUrls && (
                <Button.Icon
                  title="ACTION_SHARE"
                  icon={<Typography.Icon icon={ShareAltOutlined} />}
                  onClick={handleOnClickCompartir}
                />
              )}
              <DropdownMenu
                title={t('ACTION_MORE')}
                menu={[
                  {
                    title: t('ACTION_ACTIVITIES'),
                    icon: <SolutionOutlined />,
                    onClick: () =>
                      history.push(
                        `/analisis/${periodId}/reportesplika/${reportId}/reporte/${
                          currencyChange
                            ? currencyList.data.find((el) => el.id === currencyChange)?.id
                            : defaultCurrencyData?.id
                        }/${tabKey}/real/actividad?type=report&module=analisisDetail`,
                      ),
                  },
                ]}
              />
            </Space>
          </ButtonActionBar>
        </Col>
        {enableKpis && enableKpisReportId.reportId !== parseInt(reportId) && (
          <Col span={24}>
            <ReportKPICarousel
              dataKPI={getDataKpis()}
              isLoading={isLoadingGraphAndKpi}
              setDataComments={setDataComments}
              dataComments={dataComments}
              onRefetchComments={() => fetchCommentsList({ module: commentKey })}
              loadingComments={isLoadingComments}
              commentKey={commentKey}
              currencyData={
                currencyChange
                  ? currencyList.data.find((el) => el.id === currencyChange)
                  : defaultCurrencyData
              }
            />
          </Col>
        )}
        <Col span={24}>
          <TabsReports
            isEvolutionLoading={isEvolutionLoading}
            iscomparativeLoading={iscomparativeLoading}
            filters={filters}
            selectedDates={selectedDates}
            groupProjection={groupProjection}
            periodTableSettings={periodTableSettings}
            setPeriodTableSettings={setPeriodTableSettings}
            selectedProjection={selectedProjection}
            setSelectedProjection={setSelectedProjection}
            referenceBase={referenceBase}
            setReferenceBase={setReferenceBase}
            referenceComparison={referenceComparison}
            setReferenceComparison={setReferenceComparison}
            keyComparisonTable={keyComparisonTable}
            setKeyComparisonTable={setKeyComparisonTable}
            setTablePagination={setTablePagination}
            tablePagination={tablePagination}
            onRefetch={onRefetch}
            onRefetch2={onRefetch2}
            tabKey={tabKey}
            setTabKey={setTabKey}
            lineVertical={lineVertical}
            setLineVertical={setLineVertical}
            onRefetchComparative={onRefetchComparative}
            onRefetchEvolution={onRefetchEvolution}
            setDataComments={setDataComments}
            dataComments={dataComments}
            onRefetchComments={() => fetchCommentsList({ module: commentKey })}
            loadingComments={isLoadingComments}
            isProgressLoading={iscomparativeLoading || isEvolutionLoading}
            showProgressBar={showProgressBar}
            commentKey={commentKey}
            currencyData={
              currencyChange
                ? currencyList.data.find((el) => el.id === currencyChange)
                : defaultCurrencyData
            }
            referenceBaseVariant={referenceBaseVariant}
            setReferenceBaseVariant={setReferenceBaseVariant}
            referenceComparisonVariant={referenceComparisonVariant}
            setReferenceComparisonVariant={setReferenceComparisonVariant}
            localReferenceBase={localReferenceBase}
            setLocalReferenceBase={setLocalReferenceBase}
            dataEvolutionChart={getDataGraph()}
            lineId={lineId}
            isLoadingGraphAndKpi={isLoadingGraphAndKpi}
            overallBudgetSelectAnalysis={overallBudgetSelectAnalysis}
            type={type}
            setBaseSelect={setBaseSelect}
            baseSelect={baseSelect}
            settingsEvolution={settingsEvolution}
            settingsComparison={settingsComparison}
            settingsVariation={settingsVariation}
            setSettingsEvolution={setSettingsEvolution}
            setSettingsComparison={setSettingsComparison}
            setSettingsVariation={setSettingsVariation}
          />
        </Col>
      </Row>
      <DownloadModal
        title="PPT"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        defaultValue={folder_id}
        dataSpreadsheets={{
          type_load: 'report',
          params: {
            report_id: reportId,
            period_id: periodId,
          },
        }}
        extraAction={() =>
          downloadReportPPTDrive(reportId, {
            period_id: periodId,
            filter_date: selectedDates,
            filter: filters,
            type_report: selectedProjection,
          })
        }
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  reportDetail: reports.selectors.getReportDetail(state),
  activeOptionPeriodTable: planning.selectors.getActiveOptionPeriodTable(state),
  analysisKPIs: reports.selectors.getAnalysisKPIs(state),
  globalBudgetList: planning.selectors.getGlobalBudgetList(state),
  globalForecastFilterList: forecast.selectors.getGlobalForecastFilterList(state),
  loggedUser: login.selectors.getWhoAmI(state),

  dataKpisByReport: reports.selectors.getDataKpisByReport(state),
  dataGraphByReport: reports.selectors.getDataGraphByBaseReport(state),
  currencyList: configuration.selectors.getCurrencyList(state),
  reportStructure: reports.selectors.getReportStructure(state),
  commentsList: configuration.selectors.getCommentsList(state),
  overallBudgetSelectAnalysis: planning.selectors.getOverallBudgetSelectAnalysis(state),
})

const mapDispatchToProps = {
  fetchDataEvolution: reports.actions.fetchReportDetail,
  fetchDataComparative: reports.actions.fetchReportComparativeDetail,
  fetchGlobalBudgetList: planning.actions.fetchGlobalBudgetList,
  fetchGlobalForecastFilterList: forecast.actions.fetchGlobalForecastFilterList,
  downloadReportPPTDrive: reports.actions.downloadReportPPTDrive,
  fetchReportDetailStructure: reports.actions.fetchReportDetailStructure,

  fetchDataGraphAndKpiByReport: reports.actions.fetchDataGraphAndKpiByReport,
  fetchDataEvolutionByReport: reports.actions.fetchDataEvolutionByReport,
  fetchDataComparativeByReport: reports.actions.fetchDataComparativeByReport,
  fetchCurrencyList: configuration.actions.fetchCurrencyList,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  fetchOverallBudgetSelectAnalysis: planning.actions.fetchOverallBudgetSelectAnalysis,
  shareLayout: control.actions.shareLayout,
}

ReportDetail.propTypes = {
  commentKey: PropTypes.any,
  fetchReportDetailStructure: PropTypes.func,
  reportStructure: PropTypes.shape({
    name: PropTypes.string,
  }),
  fetchDataGraphAndKpiByReport: PropTypes.func,
  dataKpisByReport: PropTypes.array,
  dataGraphByReport: PropTypes.shape({
    rows: PropTypes.array,
  }),
  fetchDataEvolutionByReport: PropTypes.func,
  fetchDataComparativeByReport: PropTypes.func,
  fetchCurrencyList: PropTypes.func,
  currencyList: PropTypes.shape({
    data: PropTypes.array,
  }),
  fetchCommentsList: PropTypes.func,
  commentsList: PropTypes.array,
  fetchOverallBudgetSelectAnalysis: PropTypes.func,
  overallBudgetSelectAnalysis: PropTypes.any,
  type: PropTypes.string,
  globalBudgetList: PropTypes.shape({
    values: PropTypes.array,
  }),
  globalForecastFilterList: PropTypes.shape({
    values: PropTypes.array,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail)
